export const domainForCookie = () => {
    if(!window) return '.i-smet.kz'
    if(window.location.host.indexOf('ismet.kz') >= 0) {
        return '.ismet.kz'
    }
    if(window.location.host.indexOf('test-b2b.telecom.kz') >= 0) {
        return 'test-b2b.telecom.kz'
    }
    if(window.location.host.indexOf('telecom.kz') >= 0) {
        return '.telecom.kz'
    }
    if(window.location.host.indexOf('localhost') >= 0) {
        return 'localhost'
    }
    return '.i-smet.kz'
}
